<style lang="less" rel="stylesheet/less" type="text/less" scoped>
</style>
<template>
  <div class="v-customer-material-2D-views">
    <el-tabs
      v-model="tab_name"
      type="card"
      @tab-click="handleClick"
      v-loading="loading"
      element-loading-text="请稍后"
    >
      <el-tab-pane label="新增" name="新增">
        <material-create ref="create" @post="postData"></material-create>
      </el-tab-pane>

      <el-tab-pane label="查看" name="查看">
        <!-- 搜索组件 -->
        <search-form @search="confirmSearch"></search-form>

        <material-index
          :loading="loading"
          :materials="glass_2d_assets.data"
          @edit="getMaterialDetail"
          @delete="delete2DMaterial"
          @sort="confirmSearch"
        ></material-index>

        <!-- <br/> -->

        <el-pagination
          align="center"
          background
          @size-change="perPageChange"
          @current-change="pageChange"
          :current-page.sync="glass_2d_assets.current_page"
          :page-size="query_info.per_page"
          layout="sizes, prev, pager, next"
          :total="glass_2d_assets.total"
        ></el-pagination>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="修改信息" :visible.sync="show_modal" @close="closeDialog">
      <material-edit
        :materialDetail="material_detail"
        @update="update2DMaterial"
        v-loading="loading"
        element-loading-text="请稍后"
      ></material-edit>

      <div slot="footer"></div>
    </el-dialog>
  </div>
</template>

<script>
// import API_LIST from "src/API_LIST";

import qs from "qs";

import materialCreate from "./create.vue";

import materialIndex from "./index.vue";

import materialEdit from "./edit.vue";

import searchForm from "./search-form.vue";

export default {
  name: "material-2D-views",

  components: {
    materialCreate,

    materialIndex,

    materialEdit,

    searchForm
  },

  data: function() {
    return {
        token: "",
      query_info: {
        page: 1,

        per_page: 20
      },

      search_info: {
        page: 1,

        per_page: 20,
        token:''
      }, //分页信息

      loading: false,

      show_modal: false, //弹框的控制

      glass_2d_assets: {}, //2d素材

      tab_name: "新增",

      material_detail: {} //详情
    };
  },

 created() {
    this.token = sessionStorage.getItem("token");
  },
  methods: {
    /**
     * 切换tab
     * @param  {string} tab_name {tab的name}
     * @return {undefined}
     */

    handleClick(tab) {
      if (tab.name === "查看") {
        this.fetch2DMaterialList();
      } else {
        this.glass_2d_assets = {};
      }
    },

    /**
     * 关闭弹框后的回调
     * @return {undefined}
     */
    closeDialog() {
      this.material_detail = null;
    },

    /**
     * 获取素材详情
     * @param  {object} detail {素材的详情}
     * @return {undefined}
     */
    getMaterialDetail(detail) {
      this.show_modal = true;

      this.$nextTick(() => (this.material_detail = detail));
    },

    /**
     * 新增2D素材的post数据
     * @return {undefined}
     */
    postData(param) {
        console.log("9999999999",param)
      this.loading = true;

			this.axios.post(`${window.location.origin}/admin/api/v1/glass-2d-assets`, param)
			.then(({ data }) => {
					if (parseInt(data.code) !== 200) throw new Error(data.error);

					this.$message({
					  type: "success",

					  message: "新增素材成功"
					});

					this.$refs.create.handleReset("formValidate");
				})
			.catch((err) => {
					this.$message({
					  type: "error",

					  message: "新增素材失败"
					});
				})
			.then(() => (this.loading = false));


    },

    /**
     * 获取2D素材列表
     * @param  {Object} param {搜索列表的参数}
     * @return {undefined}
     */
    fetch2DMaterialList(params) {

      this.loading = true;
        if(!params){
            params={token:''}
             params.token=this.token;
        }else{
           params.token=this.token;
        }

      // params = qs.stringify(params);
           this.axios.get(`${window.location.origin}/admin/api/v1/glass-2d-assets`,{params:params})
			.then(({ data }) => {
					if (parseInt(data.code) !== 200) throw new Error(data.error);
					this.glass_2d_assets = data.glass_2d_assets;
				})
			.catch((err) => {
                    this.$message({
                      type: "error",

                      message: "获取信息失败"
                    });
				})
			.then(() => (this.loading = false));


    },

    /**
     * 更新2D素材
     * @param  {string} id    {需要更新的素材的id}
     * @param  {Object} param {需要更细的素材对象}
     * @return {undefined}
     */
    update2DMaterial(id, param ) {

        this.loading = true;

			this.axios.post(`${window.location.origin}/admin/api/v1/glass-2d-assets/`+id, param)
			.then(({ data }) => {
					if (parseInt(data.code) !== 200) throw new Error(data.error);

					this.$message({
					  type: "success",

					  message: "更新成功！"
					});
                    this.show_modal = false;
                    this.fetch2DMaterialList();
				})
			.catch((err) => {
					this.$message({
					  type: "error",

					  message: "更新失败！"
					});
				})
			.then(() => (this.loading = false));


    },

    /**
     * 删除2D素材
     * @param  {string} id {需要删除的素材的id}
     * @return {undefined}
     */

    delete2DMaterial(id) {
        const that = this;
      this.$confirm("此操作将永久删除该条记录, 是否继续?", "提示", {
        confirmButtonText: "确定",

        cancelButtonText: "取消",

        type: "warning"
      })

        .then(() => {
          const param = {
            _method: "DELETE",
            token:that.token,
          };

          this.loading = true;


            this.axios.post(`${window.location.origin}/admin/api/v1/glass-2d-assets/`+id, param)
			.then(({ data }) => {
					if (parseInt(data.code) !== 200) throw new Error(data.error);

					this.$message({
					  type: "success",

					  message: "删除成功！"
					});

					this.fetch2DMaterialList(this.search_info);
				})
			.catch((err) => {
					 this.$message({
                        type: "error",

                        message: "删除失败！"
                      });
               })
			.then(() => (this.loading = false));

        })

        .catch(() => {});
    },

    /**
     * 页码改变
     * @param  {type} pageNumber {当前页码}
     * @return {undefined}
     */
    pageChange(pageNumber) {

      this.search_info.page = pageNumber;

      this.search_info.per_page = this.query_info.per_page;
       this.search_info.token=this.token;
      this.fetch2DMaterialList(this.search_info);
    },

    /**
     * 每页显示数改变
     * @param  {type} per_page {当前每页显示数}
     * @return {undefined}
     */
    perPageChange(per_page) {
      this.search_info.per_page = per_page;
        this.search_info.token=this.token;
      this.query_info.per_page = per_page;

      this.fetch2DMaterialList(this.search_info);
    },

    /**
     * 确认搜索
     * @param  {Object} param {搜索的参数对象}
     * @return {undefined}
     */
    confirmSearch({ keyword, sort_column, sort_by }) {
    //   console.log(keyword, sort_column, sort_by);
      const param = {
        page: this.query_info.page,

        per_page: this.query_info.per_page,

        keyword: keyword,
        sort_column: sort_column,
        sort_by: sort_by
      };

      // switch (sort_by) {
      // case '':

      // 	break;
      // default:
      // 	param.order_bys = [
      // 		{
      // 			sort: sort_by,
      // 			order_by: sort_column,
      // 		},
      // 	];
      // }
        this.search_info.token=this.token;
      this.search_info = JSON.parse(JSON.stringify(param));

      this.fetch2DMaterialList(this.search_info);
    }
  }
};
</script>
